import { server } from '../constants';
import { httpClient } from '../utils/HttpClient';

/*________________________
 *  IssueCommentType Data 
 *========================
 */

/**
 * getListAll()
 * @param {object} params
 * @param {string} params.lang Default: TH
 * @returns
 * Detail: Get list all of comment type
 * API Doc: /muit-iDev/pdpa-im-api/-/wikis/Master/CommentType
 */
export function getListAll(params = { lang: 'EN' }) {
  return httpClient
    .get(`${server.ISSUE_URL}/getCommentTypeList/${params.lang}`)
    .then((result) => {
      return result.data.content;
    })
    .catch((error) => {
      throw error;
    });
}
